module.exports = __webpack_public_path__ + "static/media/new_folder.059ad1ac.svg";